import { mapActions } from 'vuex';
import filesave from 'file-saver';

export default {
    data() {
        return {
            fileData: {}
        };
    },

    methods: {
        ...mapActions('request', ['downloadFile']),
        async saveFile(name, id) {
            let data = await this.downloadFile(id);
            filesave.saveAs(data, name);
        },
        deleteFile(file) {
            const index = this.value.indexOf(file);
            this.value.splice(index, 1);
        },
        async downloadFileLocal(fileId) {
            try {
                let response = await this.downloadFile(fileId);
                this.fileData = response;
                let res = await new Promise(this.getBuffer);
                return res;
            } catch (e) {
                console.log(e);
                return null;
            }
        },
        selectFiles() {
            this.$refs.filesRef.click();
        },
        handleFiles(event) {
            let outer = this;
            let notHandle = event.target.files;

            outer.notValidFiles = []; //очищаем невалидные файлы

            if (!outer.schema.multiple) {
                outer.value = [];
            }

            for (let i = 0; i < notHandle.length; i++) {
                let file = notHandle[i];
                outer.fileData = new Blob([file]);

                if (outer.fileData.size <= 5242880) {
                    //не должен превышать 5mb
                    let promise = new Promise(outer.getBuffer);
                    promise
                        .then(function(data) {
                            (outer.value || outer.files).push({
                                name: file.name,
                                data: data
                            });
                        })
                        .catch(function(err) {
                            console.log(err);
                        });
                } else {
                    this.notValidFiles.push({
                        name: file.name,
                        error: outer.$t('превышает 5MB')
                    });
                }
            }
        },

        getBuffer(resolve) {
            let outer = this;
            let reader = new FileReader();
            reader.readAsArrayBuffer(outer.fileData);
            reader.onload = function() {
                let arrayBuffer = reader.result;
                let bytes = new Uint8Array(arrayBuffer);
                resolve(bytes);
            };
        }
    },

    computed: {}
};
